var _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReturn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 28,
    viewBox: "0 0 35 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 28,
    fill: "url(#pattern0_13932_75371)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_13932_75371",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_13932_75371",
    transform: "matrix(0.015625 0 0 0.0195312 0 -0.125)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_13932_75371",
    width: 64,
    height: 64,
    preserveAspectRatio: "none",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAYAAACqaXHeAAAACXBIWXMAAAsTAAALEwEAmpwYAAADKklEQVR4nO2aP2jTQRTHTy3+QdF2UcRB1CJYaEvzXtIiQh0EqVSc6uIsTqKbOoji6CJFndShooNdhUL83UtoS4VicbMIonUoiKJSqJDkXfTk2kaiTX5JMZek97sPvCW/g7vv93f37nfvIoTH4/F4PB6P5//RY4mdLOGxiCKcgl4l8Z0i1CJK6NGhTSzhCktkIz5SBmjq2a8IJwrCI2VAnmCIJX7/V7zzBuiVRFdKuPMGMOFRRfAhTHwhWOKimSGrAz4pgverA2eVxJk/QTjBBM+VhPtMcNEkWZ3ub2mIcJ3ub1EEN1mCqka8rWCCr0rCI2NG3cRnkokDSsJUI4WXDAlTHMAxq+LzQfwcEy40XGz4UhvR6e7WyBqglk34mKNEd7SWAK0yYVGlYiedToKqogmQUQGeEE5sgxJnWMIcE/5ckwmEC9kXPUesmaAD2MUET8IGUdP+0t2tKogNKsKHTJit0ohZne7fKmySD0mQtvrUsnePIrjHEn9VNEHCbWGbTJkEabtfJXGAJX6psBRyGYJDtsciSiVI650KIXKyp4sJvlXIQyOiXnBRgqxbnynoNW86ZBZkdbJrd73GIwoJsm4dLi+HWxVmwSXhMnqsfUvY1syEKeE6THgtdBmMtW8RLqPHYS8T5MuZkJMQE66jJLwtZ4Ap3wnXYQnPQhLhZeE6iuBO+TwAV4XrKInD0TaA8EH5JQAXhOsowunyByM8LVxGj3ZsXiqGlDHAHNqEy+QpfjbkQ+iz1mKDcBlV4n6yKAHW9WxSdxTBqdDCSArOCFfRk51tTDAf8vbnG3adZhv9sm8bEwSRPArrZNd2lpgMFw9z1gujjWCp8rTyV5zQkDggXIIlJFji07Bjb1HctTYQne7YYZLPX79NdrYVwnx0ZAI8aKK4TTaIH+ZUDEpFcTtzs7McscEcxc+b+wBF8KYK0StvHsbNh1FNRasSHVV6Xm2btbSrQvwrU5esqfj1YgBLkFbEN7sBS7dEEodrPu3XhwHw2uwKwjaq+QyYNnU+fUNstC6+GQxgwh9MmGaC61avvptrG4Tj5pmWffuqGpjH4/F4PB6PR6yJ3+j6a3Urj7FUAAAAAElFTkSuQmCC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReturn);
export default __webpack_public_path__ + "static/media/return.e2adbb3719387932ffa3556ae8b5976e.svg";
export { ForwardRef as ReactComponent };